import imgAccessBatchExportPage from './images/accessBatchExportPage.png';
import imgAccountMenu from './images/accountMenu.png';
import imgAccountMenuPreferences from './images/accountMenuPreferences.png';
import imgAccountMenuSystemStatus from './images/accountMenuSystemStatus.png';
import imgAddAlert from './images/addAlert.png';
import imgAlertDetails from './images/alertDetails.png';
import imgAlertsPage from './images/alertsPage.png';
import imgAzureEventHubConfig from './images/azureEventHubConfig.png';
import imgAzureEventHubFindDiagnosticSettings from './images/azureEventHubFindDiagnosticSettings.png';
import imgAzureEventHubSetDiagnosticSettings from './images/azureEventHubSetDiagnosticSettings.png';
import imgBatchExportPage from './images/batchExportPage.png';
import imgBreakdownGraph from './images/breakdownGraph.png';
import imgCostManagementAddCategory from './images/costManagementAddCategory.png';
import imgCostManagementDisableFilter from './images/costManagementDisableFilter.png';
import imgCostManagementDiscardFilter from './images/costManagementDiscardFilter.png';
import imgCostManagementFilterOrdering from './images/costManagementFilterOrdering.png';
import imgCostManagementNotifications from './images/costManagementNotifications.png';
import imgCostManagementOverview from './images/costManagementOverview.png';
import imgCrossTeamSearch from './images/crossTeamSearch.png';
import imgDashAddBreakdown from './images/dashAddBreakdown.png';
import imgDashAddFilter from './images/dashAddFilter.png';
import imgDashAddGraph from './images/dashAddGraph.png';
import imgDashAddMarkdown from './images/dashAddMarkdown.png';
import imgDashAddNumber from './images/dashAddNumber.png';
import imgDashAddPie from './images/dashAddPie.png';
import imgDashAddPlot from './images/dashAddPlot.png';
import imgDashAddTab from './images/dashAddTab.png';
import imgDashAddTable from './images/dashAddTable.png';
import imgDashAddTabsDialog from './images/dashAddTabsDialog.png';
import imgDashboardOverview from './images/dashboardOverview.png';
import imgDashCustomFilter from './images/dashCustomFilter.png';
import imgDashEditFillters from './images/dashEditFillters.png';
import imgDashEditTabs from './images/dashEditTabs.png';
import imgDashFieldFilter from './images/dashFieldFilter.png';
import imgDashManageFilters from './images/dashManageFilters.png';
import imgDashMoveTabs from './images/dashMoveTabs.png';
import imgDistributionOverview from './images/distributionOverview.png';
import imgEventDetails from './images/eventDetails.png';
import imgEventTextSelection from './images/eventTextSelection.png';
import imgExternalBlockDiagram from './images/external-block-diagram.png';
import imgGraphOverview from './images/graphOverview.png';
import imgGraphType from './images/graphType.png';
import imgGraphableFieldValues from './images/graphableFieldValues.png';
import imgHindsight from './images/hindsight.png';
import imgInternalBlockDiagram from './images/internal-block-diagram.png';
import imgKubernetesOverview from './images/kubernetesOverview.png';
import imgLogOverview from './images/logOverview.png';
import imgLogViewSettings from './images/logViewSettings.png';
import imgLogsOverview from './images/logsOverview.png';
import imgLogtext from './images/logtext.png';
import imgManageApiKeys from './images/manageApiKeys.png';
import imgPostToSlack from './images/postToSlack.png';
import imgPostToSlackAuth from './images/postToSlackAuth.png';
import imgPostToSlackChannel from './images/postToSlackChannel.png';
import imgPostToSlackMenu from './images/postToSlackMenu.png';
import imgPowerQueryGraphs from './images/powerqueryGraphs.png';
import imgPowerQueryOverview from './images/powerqueryOverview.png';
import imgScrubbingForm from './images/scrubbing-form.png';
import imgSearchHelper from './images/searchHelper.png';
import imgSearchHelperHelp from './images/searchHelperHelp.png';
import imgSearchHelperTypes from './images/searchHelperTypes.png';
import imgSearchHelperValues from './images/searchHelperValues.png';
import imgSolutionS3Perms from './images/solutionS3Perms.png';
import imgTimeDropdown from './images/timeDropdown.png';
import imgTimeDropdown3Day from './images/timeDropdown3Day.png';

import imgDarkAccountMenu from './images/dark/accountMenu.png';
import imgDarkAccountMenuPreferences from './images/dark/accountMenuPreferences.png';
import imgDarkAccessBatchExportPage from './images/dark/accessBatchExportPage.png';
import imgDarkAddAlert from './images/dark/addAlert.png';
import imgDarkAlertDetails from './images/dark/alertDetails.png';
import imgDarkAlertsPage from './images/dark/alertsPage.png';
import imgDarkAzureEventHubConfig from './images/dark/azureEventHubConfig.png';
import imgDarkAzureEventHubFindDiagnosticSettings from './images/dark/azureEventHubFindDiagnosticSettings.png';
import imgDarkAzureEventHubSetDiagnosticSettings from './images/dark/azureEventHubSetDiagnosticSettings.png';
import imgDarkBatchExportPage from './images/dark/batchExportPage.png';
import imgDarkBreakdownGraph from './images/dark/breakdownGraph.png';
import imgDarkCostManagementAddCategory from './images/dark/costManagementAddCategory.png';
import imgDarkCostManagementDisableFilter from './images/dark/costManagementDisableFilter.png';
import imgDarkCostManagementDiscardFilter from './images/dark/costManagementDiscardFilter.png';
import imgDarkCostManagementFilterOrdering from './images/dark/costManagementFilterOrdering.png';
import imgDarkCostManagementNotifications from './images/dark/costManagementNotifications.png';
import imgDarkCostManagementOverview from './images/dark/costManagementOverview.png';
import imgDarkCrossTeamSearch from './images/dark/crossTeamSearch.png';
import imgDarkDashAddBreakdown from './images/dark/dashAddBreakdown.png';
import imgDarkDashAddFilter from './images/dark/dashAddFilter.png';
import imgDarkDashAddGraph from './images/dark/dashAddGraph.png';
import imgDarkDashAddMarkdown from './images/dark/dashAddMarkdown.png';
import imgDarkDashAddNumber from './images/dark/dashAddNumber.png';
import imgDarkDashAddPie from './images/dark/dashAddPie.png';
import imgDarkDashAddPlot from './images/dark/dashAddPlot.png';
import imgDarkDashAddTab from './images/dark/dashAddTab.png';
import imgDarkDashAddTable from './images/dark/dashAddTable.png';
import imgDarkDashAddTabsDialog from './images/dark/dashAddTabsDialog.png';
import imgDarkDashboardOverview from './images/dark/dashboardOverview.png';
import imgDarkDashCustomFilter from './images/dark/dashCustomFilter.png';
import imgDarkDashEditFillters from './images/dark/dashEditFillters.png';
import imgDarkDashEditTabs from './images/dark/dashEditTabs.png';
import imgDarkDashFieldFilter from './images/dark/dashFieldFilter.png';
import imgDarkDashManageFilters from './images/dark/dashManageFilters.png';
import imgDarkDashMoveTabs from './images/dark/dashMoveTabs.png';
import imgDarkDistributionOverview from './images/dark/distributionOverview.png';
import imgDarkEventDetails from './images/dark/eventDetails.png';
import imgDarkEventTextSelection from './images/dark/eventTextSelection.png';
import imgDarkExternalBlockDiagram from './images/dark/external-block-diagram.png';
import imgDarkGraphOverview from './images/dark/graphOverview.png';
import imgDarkGraphType from './images/dark/graphType.png';
import imgDarkGraphableFieldValues from './images/dark/graphableFieldValues.png';
import imgDarkHindsight from './images/dark/hindsight.png';
import imgDarkInternalBlockDiagram from './images/dark/internal-block-diagram.png';
import imgDarkKubernetesOverview from './images/dark/kubernetesOverview.png';
import imgDarkLogOverview from './images/dark/logOverview.png';
import imgDarkLogViewSettings from './images/dark/logViewSettings.png';
import imgDarkLogsOverview from './images/dark/logsOverview.png';
import imgDarkLogtext from './images/dark/logtext.png';
import imgDarkManageApiKeys from './images/dark/manageApiKeys.png';
import imgDarkPostToSlack from './images/dark/postToSlack.png';
import imgDarkPostToSlackAuth from './images/dark/postToSlackAuth.png';
import imgDarkPostToSlackChannel from './images/dark/postToSlackChannel.png';
import imgDarkPostToSlackMenu from './images/dark/postToSlackMenu.png';
import imgDarkPowerQueryGraphs from './images/dark/powerqueryGraphs.png';
import imgDarkPowerQueryOverview from './images/dark/powerqueryOverview.png';
import imgDarkScrubbingForm from './images/dark/scrubbing-form.png';
import imgDarkSearchHelper from './images/dark/searchHelper.png';
import imgDarkSearchHelperHelp from './images/dark/searchHelperHelp.png';
import imgDarkSearchHelperTypes from './images/dark/searchHelperTypes.png';
import imgDarkSearchHelperValues from './images/dark/searchHelperValues.png';
import imgDarkSolutionS3Perms from './images/dark/solutionS3Perms.png';
import imgDarkTimeDropdown from './images/dark/timeDropdown.png';
import imgDarkTimeDropdown3Day from './images/dark/timeDropdown3Day.png';

import imgLogoApache from './images/logos/logo-apache.png';
import imgLogoAzureEventHubs from './images/logos/logo-azure.png';
import imgLogoAppHarbor from './images/logos/logo-appharbor.png';
import imgLogoCloudfront from './images/logos/logo-cloudfront.png';
import imgLogoCloudtrail from './images/logos/logo-cloudtrail.png';
import imgLogoCloudwatch from './images/logos/logo-cloudwatch.png';
import imgLogoContainerd from './images/logos/logo-containerd.png';
import imgLogoDarkContainerd from './images/logos/logo-containerd-dark.png';
import imgLogoCrio from './images/logos/logo-crio.png';
import imgLogoDarkCrio from './images/logos/logo-crio-dark.png';
import imgLogoDatastudio from './images/logos/logo-datastudio.png';
import imgLogoDocker from './images/logos/logo-docker.png';
import imgLogoEC2 from './images/logos/logo-ec2.png';
import imgLogoELB from './images/logos/logo-elb.png';
import imgLogoFargate from './images/logos/logo-fargate.png';
import imgLogoFluentBit from './images/logos/logo-fluent-bit.png';
import imgLogoFluentd from './images/logos/logo-fluentd.png';
import imgLogoGrafana from './images/logos/logo-grafana.png';
import imgLogoGraphite from './images/logos/logo-graphite.png';
import imgLogoHelm from './images/logos/logo-helm.png';
import imgLogoDarkHelm from './images/logos/logo-helm-dark.png';
import imgLogoHeroku from './images/logos/logo-heroku.png';
import imgLogoHTTP from './images/logos/logo-http.png';
import imgLogoKafka from './images/logos/logo-kafka.png';
import imgLogoDarkKafka from './images/logos/logo-kafka-dark.png';
import imgLogoKubernetes from './images/logos/logo-kubernetes.png';
import imgLogoDarkKubernetes from './images/logos/logo-kubernetes-dark.png';
import imgLogoLinux from './images/logos/logo-linux.png';
import imgLogoLogstash from './images/logos/logo-logstash.png';
import imgLogoMysql from './images/logos/logo-mysql.png';
import imgLogoNginx from './images/logos/logo-nginx.png';
import imgLogoOkta from './images/logos/logo-okta.png';
import imgLogoOnelogin from './images/logos/logo-onelogin.png';
import imgLogoDarkOnelogin from './images/logos/logo-onelogin-dark.png';
import imgLogoPostgres from './images/logos/logo-postgres.png';
import imgLogoRDS from './images/logos/logo-rds.png';
import imgLogoRedis from './images/logos/logo-redis.png';
import imgLogoRedshift from './images/logos/logo-redshift.png';
import imgLogoS3 from './images/logos/logo-s3.png';
import imgLogoSNMP from './images/logos/logo-snmp.png';
import imgLogoSyslog from './images/logos/logo-syslog.png';
import imgLogoWindows from './images/logos/logo-windows.png';

const HELP_IMAGE: Record<string, any> = {
  light: {
    'accountMenu.png': imgAccountMenu,
    'accountMenuPreferences.png': imgAccountMenuPreferences,
    'accountMenuSystemStatus.png': imgAccountMenuSystemStatus,
    'accessBatchExportPage.png': imgAccessBatchExportPage,
    'addAlert.png': imgAddAlert,
    'alertDetails.png': imgAlertDetails,
    'alertsPage.png': imgAlertsPage,
    'azureEventHubConfig.png': imgAzureEventHubConfig,
    'azureEventHubFindDiagnosticSettings.png': imgAzureEventHubFindDiagnosticSettings,
    'azureEventHubSetDiagnosticSettings.png': imgAzureEventHubSetDiagnosticSettings,
    'batchExportPage.png': imgBatchExportPage,
    'breakdownGraph.png': imgBreakdownGraph,
    'costManagementAddCategory.png': imgCostManagementAddCategory,
    'costManagementDisableFilter.png': imgCostManagementDisableFilter,
    'costManagementDiscardFilter.png': imgCostManagementDiscardFilter,
    'costManagementFilterOrdering.png': imgCostManagementFilterOrdering,
    'costManagementNotifications.png': imgCostManagementNotifications,
    'costManagementOverview.png': imgCostManagementOverview,
    'crossTeamSearch.png': imgCrossTeamSearch,
    'dashAddBreakdown.png': imgDashAddBreakdown,
    'dashAddFilter.png': imgDashAddFilter,
    'dashAddGraph.png': imgDashAddGraph,
    'dashAddMarkdown.png': imgDashAddMarkdown,
    'dashAddNumber.png': imgDashAddNumber,
    'dashAddPie.png': imgDashAddPie,
    'dashAddPlot.png': imgDashAddPlot,
    'dashAddTab.png': imgDashAddTab,
    'dashAddTable.png': imgDashAddTable,
    'dashAddTabsDialog.png': imgDashAddTabsDialog,
    'dashboardOverview.png': imgDashboardOverview,
    'dashCustomFilter.png': imgDashCustomFilter,
    'dashEditFillters.png': imgDashEditFillters,
    'dashEditTabs.png': imgDashEditTabs,
    'dashFieldFilter.png': imgDashFieldFilter,
    'dashManageFilters.png': imgDashManageFilters,
    'dashMoveTabs.png': imgDashMoveTabs,
    'distributionOverview.png': imgDistributionOverview,
    'eventDetails.png': imgEventDetails,
    'eventTextSelection.png': imgEventTextSelection,
    'external-block-diagram.png': imgExternalBlockDiagram,
    'graphOverview.png': imgGraphOverview,
    'graphType.png': imgGraphType,
    'graphableFieldValues.png': imgGraphableFieldValues,
    'hindsight.png': imgHindsight,
    'internal-block-diagram.png': imgInternalBlockDiagram,
    'kubernetesOverview.png': imgKubernetesOverview,
    'logOverview.png': imgLogOverview,
    'logViewSettings.png': imgLogViewSettings,
    'logsOverview.png': imgLogsOverview,
    'logtext.png': imgLogtext,
    'manageApiKeys.png': imgManageApiKeys,
    'postToSlack.png': imgPostToSlack,
    'postToSlackAuth.png': imgPostToSlackAuth,
    'postToSlackChannel.png': imgPostToSlackChannel,
    'postToSlackMenu.png': imgPostToSlackMenu,
    'powerqueryGraphs.png': imgPowerQueryGraphs,
    'powerqueryOverview.png': imgPowerQueryOverview,
    'scrubbing-form.png': imgScrubbingForm,
    'searchHelper.png': imgSearchHelper,
    'searchHelperHelp.png': imgSearchHelperHelp,
    'searchHelperTypes.png': imgSearchHelperTypes,
    'searchHelperValues.png': imgSearchHelperValues,
    'solutionS3Perms.png': imgSolutionS3Perms,
    'timeDropdown.png': imgTimeDropdown,
    'timeDropdown3Day.png': imgTimeDropdown3Day,

    'logo-apache.png': imgLogoApache,
    'logo-appharbor.png': imgLogoAppHarbor,
    'logo-azure.png': imgLogoAzureEventHubs,
    'logo-cloudfront.png': imgLogoCloudfront,
    'logo-cloudtrail.png': imgLogoCloudtrail,
    'logo-cloudwatch.png': imgLogoCloudwatch,
    'logo-containerd.png': imgLogoContainerd,
    'logo-crio.png': imgLogoCrio,
    'logo-datastudio.png': imgLogoDatastudio,
    'logo-docker.png': imgLogoDocker,
    'logo-ec2.png': imgLogoEC2,
    'logo-elb.png': imgLogoELB,
    'logo-fargate.png': imgLogoFargate,
    'logo-fluent-bit.png': imgLogoFluentBit,
    'logo-fluentd.png': imgLogoFluentd,
    'logo-grafana.png': imgLogoGrafana,
    'logo-graphite.png': imgLogoGraphite,
    'logo-helm.png': imgLogoHelm,
    'logo-heroku.png': imgLogoHeroku,
    'logo-http.png': imgLogoHTTP,
    'logo-kafka.png': imgLogoKafka,
    'logo-kubernetes.png': imgLogoKubernetes,
    'logo-linux.png': imgLogoLinux,
    'logo-logstash.png': imgLogoLogstash,
    'logo-mysql.png': imgLogoMysql,
    'logo-nginx.png': imgLogoNginx,
    'logo-okta.png': imgLogoOkta,
    'logo-onelogin.png': imgLogoOnelogin,
    'logo-postgres.png': imgLogoPostgres,
    'logo-rds.png': imgLogoRDS,
    'logo-redis.png': imgLogoRedis,
    'logo-redshift.png': imgLogoRedshift,
    'logo-s3.png': imgLogoS3,
    'logo-snmp.png': imgLogoSNMP,
    'logo-syslog.png': imgLogoSyslog,
    'logo-windows.png': imgLogoWindows,
  },

  dark: {
    'accountMenu.png': imgDarkAccountMenu,
    'accountMenuPreferences.png': imgDarkAccountMenuPreferences,
    'accountMenuSystemStatus.png': imgAccountMenuSystemStatus,
    'accessBatchExportPage.png': imgDarkAccessBatchExportPage,
    'addAlert.png': imgDarkAddAlert,
    'alertDetails.png': imgDarkAlertDetails,
    'alertsPage.png': imgDarkAlertsPage,
    'azureEventHubConfig.png': imgDarkAzureEventHubConfig,
    'azureEventHubFindDiagnosticSettings.png': imgDarkAzureEventHubFindDiagnosticSettings,
    'azureEventHubSetDiagnosticSettings.png': imgDarkAzureEventHubSetDiagnosticSettings,
    'batchExportPage.png': imgDarkBatchExportPage,
    'breakdownGraph.png': imgDarkBreakdownGraph,
    'costManagementAddCategory.png': imgDarkCostManagementAddCategory,
    'costManagementDisableFilter.png': imgDarkCostManagementDisableFilter,
    'costManagementDiscardFilter.png': imgDarkCostManagementDiscardFilter,
    'costManagementFilterOrdering.png': imgDarkCostManagementFilterOrdering,
    'costManagementNotifications.png': imgDarkCostManagementNotifications,
    'costManagementOverview.png': imgDarkCostManagementOverview,
    'crossTeamSearch.png': imgDarkCrossTeamSearch,
    'dashAddBreakdown.png': imgDarkDashAddBreakdown,
    'dashAddFilter.png': imgDarkDashAddFilter,
    'dashAddGraph.png': imgDarkDashAddGraph,
    'dashAddMarkdown.png': imgDarkDashAddMarkdown,
    'dashAddNumber.png': imgDarkDashAddNumber,
    'dashAddPie.png': imgDarkDashAddPie,
    'dashAddPlot.png': imgDarkDashAddPlot,
    'dashAddTab.png': imgDarkDashAddTab,
    'dashAddTable.png': imgDarkDashAddTable,
    'dashAddTabsDialog.png': imgDarkDashAddTabsDialog,
    'dashboardOverview.png': imgDarkDashboardOverview,
    'dashCustomFilter.png': imgDarkDashCustomFilter,
    'dashEditFillters.png': imgDarkDashEditFillters,
    'dashEditTabs.png': imgDarkDashEditTabs,
    'dashFieldFilter.png': imgDarkDashFieldFilter,
    'dashManageFilters.png': imgDarkDashManageFilters,
    'dashMoveTabs.png': imgDarkDashMoveTabs,
    'distributionOverview.png': imgDarkDistributionOverview,
    'eventDetails.png': imgDarkEventDetails,
    'eventTextSelection.png': imgDarkEventTextSelection,
    'external-block-diagram.png': imgDarkExternalBlockDiagram,
    'graphOverview.png': imgDarkGraphOverview,
    'graphType.png': imgDarkGraphType,
    'graphableFieldValues.png': imgDarkGraphableFieldValues,
    'hindsight.png': imgDarkHindsight,
    'internal-block-diagram.png': imgDarkInternalBlockDiagram,
    'kubernetesOverview.png': imgDarkKubernetesOverview,
    'logOverview.png': imgDarkLogOverview,
    'logViewSettings.png': imgDarkLogViewSettings,
    'logsOverview.png': imgDarkLogsOverview,
    'logtext.png': imgDarkLogtext,
    'manageApiKeys.png': imgDarkManageApiKeys,
    'postToSlack.png': imgDarkPostToSlack,
    'postToSlackAuth.png': imgDarkPostToSlackAuth,
    'postToSlackChannel.png': imgDarkPostToSlackChannel,
    'postToSlackMenu.png': imgDarkPostToSlackMenu,
    'powerqueryGraphs.png': imgDarkPowerQueryGraphs,
    'powerqueryOverview.png': imgDarkPowerQueryOverview,
    'scrubbing-form.png': imgDarkScrubbingForm,
    'searchHelper.png': imgDarkSearchHelper,
    'searchHelperHelp.png': imgDarkSearchHelperHelp,
    'searchHelperTypes.png': imgDarkSearchHelperTypes,
    'searchHelperValues.png': imgDarkSearchHelperValues,
    'solutionS3Perms.png': imgDarkSolutionS3Perms,
    'timeDropdown.png': imgDarkTimeDropdown,
    'timeDropdown3Day.png': imgDarkTimeDropdown3Day,

    'logo-apache.png': imgLogoApache,
    'logo-appharbor.png': imgLogoAppHarbor,
    'logo-azure.png': imgLogoAzureEventHubs,
    'logo-cloudfront.png': imgLogoCloudfront,
    'logo-cloudtrail.png': imgLogoCloudtrail,
    'logo-cloudwatch.png': imgLogoCloudwatch,
    'logo-containerd.png': imgLogoDarkContainerd,
    'logo-crio.png': imgLogoDarkCrio,
    'logo-datastudio.png': imgLogoDatastudio,
    'logo-docker.png': imgLogoDocker,
    'logo-ec2.png': imgLogoEC2,
    'logo-elb.png': imgLogoELB,
    'logo-fargate.png': imgLogoFargate,
    'logo-fluent-bit.png': imgLogoFluentBit,
    'logo-fluentd.png': imgLogoFluentd,
    'logo-grafana.png': imgLogoGrafana,
    'logo-graphite.png': imgLogoGraphite,
    'logo-helm.png': imgLogoDarkHelm,
    'logo-heroku.png': imgLogoHeroku,
    'logo-http.png': imgLogoHTTP,
    'logo-kafka.png': imgLogoDarkKafka,
    'logo-kubernetes.png': imgLogoDarkKubernetes,
    'logo-linux.png': imgLogoLinux,
    'logo-logstash.png': imgLogoLogstash,
    'logo-mysql.png': imgLogoMysql,
    'logo-nginx.png': imgLogoNginx,
    'logo-okta.png': imgLogoOkta,
    'logo-onelogin.png': imgLogoDarkOnelogin,
    'logo-postgres.png': imgLogoPostgres,
    'logo-rds.png': imgLogoRDS,
    'logo-redis.png': imgLogoRedis,
    'logo-redshift.png': imgLogoRedshift,
    'logo-s3.png': imgLogoS3,
    'logo-snmp.png': imgLogoSNMP,
    'logo-syslog.png': imgLogoSyslog,
    'logo-windows.png': imgLogoWindows,
  },
};

export default HELP_IMAGE;
